export const ADD_RESERVATION_SUCCESS = "redux_store:reservations.success.post";
export const DELETE_RESERVATION_SUCCESS = "redux_store:reservations.success.delete";
export const UPDATE_RESERVATION_SUCCESS = "redux_store:reservations.success.patch";
export const CONFIRM_RESERVATION_SUCCESS = "redux_store:reservations.success.confirm";
export const CANCEL_RESERVATION_SUCCESS = "redux_store:reservations.success.cancel";


// WEBPACK FOOTER //
// ./src/successes/reservations.js